module.exports = __webpack_public_path__ + "res/ic_arrow_small_big_m.95e39aa1ed7e91b49dec57effdbc761e.png";